import { Button, CircularProgress } from "@mui/material"

export const SubmitButton = ({text, variant = "contained", color='secondary', isSubmitting, isValid, disabled, onClick=null}) => {
    return (
        <Button
        variant={variant}
        color={color}
        type="submit"
        disabled={isSubmitting || !isValid || disabled}
        onClick={onClick}
      >
        {isSubmitting && (
          <CircularProgress
            size={24}
            color="secondary"
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        )}
        {text}
      </Button>
    )
}